export default function initGridToggleProducts() {
    // TRAVA DE SEGURANÇA: Só executa este script na página de categorias de produtos
    if (!document.body.classList.contains('tax-categoria-produto')) {
        return;
    }

    const btnDefault = document.querySelector('.c-grid-area__btn--layout-default');
    const btnDense = document.querySelector('.c-grid-area__btn--layout-dense');

    // Em vez de focar no wrapper do ASP que é destruído no AJAX,
    // focamos no container pai da sua própria interface que é imutável.
    const gridAreaParent = document.querySelector('.c-grid-area');

    if (!btnDefault || !btnDense || !gridAreaParent) return;

    // Ação para o Layout Padrão (1 ou 3)
    btnDefault.addEventListener('click', () => {
        gridAreaParent.classList.remove('c-grid-area--layout-dense');

        btnDefault.setAttribute('aria-pressed', 'true');
        btnDense.setAttribute('aria-pressed', 'false');
    });

    // Ação para o Layout Denso (2 ou 4)
    btnDense.addEventListener('click', () => {
        gridAreaParent.classList.add('c-grid-area--layout-dense');

        btnDense.setAttribute('aria-pressed', 'true');
        btnDefault.setAttribute('aria-pressed', 'false');
    });
}